import { useAppSelector } from '../../hooks/store-hooks';
import { TutorialComponents } from './components/TutorialComponents';
import { HomeSideBar } from './HomeSideBar';
import HomeEventProvider from './providers/HomeEventProvider';
import Workspaces from './workspaces/Workspaces';

export default function Home() {
    const fullscreen = useAppSelector((x) => x.global.fullscreen);

    return (
        <div className="d-flex h-100">
            <div className="flex-grow-1 min-w-0">
                <TutorialComponents />
                <Workspaces />
            </div>
            <HomeEventProvider />
            {!fullscreen && <HomeSideBar />}
        </div>
    );
}
